<div id="patient_bot">
  <!-- <div *ngIf="bannerJson != undefined">
  <app-resource-banner [bannerJson]="bannerJson" (patientResult)="patientResult($event);"></app-resource-banner>
</div> -->
<div class="main-content-container shadow border rounded">
  <div class="main-container-body">
    <div class="form-container">
      <form [formGroup]="fg" (ngSubmit)="onSubmit()">
        <div class="row pl-3 w-100">
          <div class="col-6 form-group kx-control fix">
            <label class="control-label font-weight-bold required" for="">Chief Complaints</label>
            <kx-multiselect-dropdown tabindex="-1" [questions]="chiefcomplaint.question" name="chief_complaints"
              [controlName]="fg" [placeholder]="'Select Chief Complaint'" [data]="chiefcomplaint.datasource"
              [formControlName]="'chief_complaints'" [settings]="chiefcomplaint.defaultsetting"
              (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeselect($event)" [disabled]="this['data'] != undefined">
            </kx-multiselect-dropdown>
          </div>
          @if (this['data'] != undefined) {
            <div class="col-6 form-group kx-control fix">
              <label class="control-label font-weight-bold required" for="">CDSS Name</label>
              <input type="text" class="form-control" [value]="result.cdss_name" disabled>
            </div>
          }
          @if (this['data'] == undefined) {
            <div class="col-6 form-group kx-control fix">
              <label class="control-label font-weight-bold required" for="">CDSS Name</label>
              <select class="form-control" (change)="getTransactionData($event)" formControlName="cdss_name"  name="cdss_name">
                <option value="" [disabled]="true">Select CDSS Name</option>
                @for (cdss of result.cdssNames; track cdss) {
                  <option
                  [value]="cdss.cdss_code">{{cdss.cdss_name}}</option>
                }
              </select>
            </div>
          }
        </div>
        <div class="row pl-3 w-100">
          @if (result.remarks && (result.remarks != '' || result.remarks != null)) {
            <div class="col-12 form-group kx-control fix">
              <label class="control-label font-weight-bold" for="">Remarks</label>
              <textarea class="form-control" [value]="result.remarks" disabled></textarea>
            </div>
          }
        </div>
        @if (result.allQuestions != undefined && result.allQuestions.length > 0) {
          <div class="cdss-questions _wf-qa-main-container">
            @for (ques of result.allQuestions; track ques; let i = $index) {
              <div class="cdss-q-s _wf-qa-container">
                @if (i>0) {
                  <div class="line1"></div>
                }
                <div class="_wf-qa-question-block cdss_{{ques.question_code}}" [ngClass]="ques.type == 'recommendation' ? 'mb-2': ''">
                  @if (ques.type == 'question') {
                    <b>{{ques.question_text}}</b>
                  }
                  @if (ques.type == 'recommendation') {
                    <b (onCreate)="recommend();">{{ques.recommend}}</b>
                  }
                </div>
                @if (ques.type == 'question' && ques.answers != undefined && ques.answers.length > 0) {
                  <ul class="_wf-qa-answer-block">
                    @for (answer of ques.answers; track answer) {
                      <li class="nav-item m-2 cdss-a-{{answer.id}}">
                        <div class="radio">
                          <label class="kx-radio-wrapper" for="{{answer.id}}" >
                            {{answer.text}}
                            <input id="{{answer.id}}" type="radio" [checked]="ques.value == answer.id ? true : false" value="{{answer.id}}" (click)="selectAnswer(answer,ques);" name="radio_{{ques.question_code}}" [disabled]="this['data'] != undefined">
                            <span class="kx-radio-check"></span>
                          </label>
                        </div>
                      </li>
                    }
                  </ul>
                }
                @if (ques.type == 'orderset' && ques.orderset != undefined && ques.orderset.length > 0) {
                  <ul class="_wf-qa-answer-block">
                    @for (answer of ques.orderset; track answer) {
                      <li class="nav-item m-2 cdss-orderset-{{answer.id}}">
                        <div class="radio">
                          <label class="kx-radio-wrapper" for="{{answer.id}}" >
                            {{answer.text}}
                            <input id="{{answer.id}}" type="radio" value="{{answer.id}}" [checked]="ques.value == answer.id ? true : false" (click)="getOrderSetValue(answer,ques);" name="radio_{{ques.question_code}}" [disabled]="this['data'] != undefined">
                            <span class="kx-radio-check"></span>
                          </label>
                        </div>
                      </li>
                    }
                  </ul>
                }
              </div>
            }
            @if (result.ordersetData && (result.ordersetData.clinicalOrder || result.ordersetData.medicationRequest)) {
              <div class="main-content-container shadow border rounded mt-3 mb-3 p-2 text-center" style="background: #edf0f3;">
                @if (result.ordersetData.clinicalOrder) {
                  <div class="custom-block m-2">
                    @for (order of result.ordersetData.clinicalOrder; track order) {
                      <div>{{order.serviceType}} Test Name : {{order.name}}</div>
                    }
                  </div>
                }
                @if (result.ordersetData.medicationRequest) {
                  <div class="custom-block m-2">
                    @for (order of result.ordersetData.medicationRequest; track order) {
                      <div>Medicine Name : {{order.itemName}} in the form of {{order.issueUnitKey}}</div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (checkOrdersetData()) {
          <div class="row form-primary-actions sticky-add-btn mt-3">
            <div class="col-12 text-center"><button class="primary-btn" >Go to E-Prescription <i class="fa fa-file" aria-hidden="true"></i></button></div>
          </div>
        }
      </form>
    </div>

  </div>

</div>
</div>

